import React, { useEffect, useState } from 'react';
import { IStepperProps } from './stepper.models';
import { Steps } from './steps/steps';
import { FauxChild } from '@keplerco/core';
import { IStepProps } from './step/step.models';
import { canGoTo } from './stepper.helpers';

export function Stepper({ setStepCount, activeStepNumber, goTo, children }: React.PropsWithChildren<IStepperProps>) {
  const [steps, setSteps] = useState<React.PropsWithChildren<IStepProps>[]>();

  useEffect(() => {
    const fauxChildren: FauxChild<IStepProps>[] = (Array.isArray(children) ? children : [children]) as any;
    const steps: IStepProps[] = [];
    fauxChildren
      .map(fauxChild => fauxChild.props)
      .filter(step => !!step.label)
      .forEach((step, index) => steps.push({ ...step, disabled: !canGoTo(!!step.disabled, index, steps) }));
    setSteps(steps);
    setStepCount(steps.length);
  }, [children]);

  useEffect(() => {
    const activeStepIndex = activeStepNumber - 1;
    const previousStepNumber = activeStepNumber - 1;
    if (steps?.[activeStepIndex].disabled) goTo(previousStepNumber);
  }, [steps]);

  return (
    <React.Fragment>
      <Steps steps={steps ?? []} activeStepNumber={activeStepNumber} goTo={goTo} />
      {!!steps?.length && steps[activeStepNumber - 1].children}
    </React.Fragment>
  );
}
